import { render, staticRenderFns } from "./warningWallet.vue?vue&type=template&id=1b53a76e&"
import script from "./warningWallet.vue?vue&type=script&lang=js&"
export * from "./warningWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports